function storeRecentSearch(term) {
    let recent = JSON.parse(localStorage.getItem("recentSearches") || "[]");
    recent = [term, ...recent.filter((item) => item !== term)].slice(0, 10);
    localStorage.setItem("recentSearches", JSON.stringify(recent));
}
function renderRecentSearches() {
    const wrapper = document.querySelector(".search-auto-popup__latest-searchs");
    const list = document.querySelector(".latest-searchs__list ul");
    if (!wrapper || !list) return;

    const recent = JSON.parse(localStorage.getItem("recentSearches") || "[]");

    if (!recent.length) {
        wrapper.style.display = "none";
        return;
    }

    wrapper.style.display = "flex";
    list.innerHTML = recent.map((term) => `
                <li>
                <a href="javascript:;" class="recent-search-item" data-search="${encodeURIComponent(term)}">
                    <span>${term}</span>
                    <img class="remove-recent-search" data-search="${encodeURIComponent(term)}"
                    src="https://cdn.shopify.com/s/files/1/0265/5164/8355/files/remove-recent-search-icon.png?v=1782812386" alt="remove recent search">
                </a>
                </li>
            `).join("");
}

function slideUp(element, duration = 300) {
    // console.log("slideUp : ", element);
    
    element.style.height = element.offsetHeight + 'px';
    element.offsetHeight; // force repaint
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = 0;

    setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
    }, duration);
}

function slideDown(element, duration = 300) {
    // console.log("slideDown : ", element);
    element.style.removeProperty('display');
    if (getComputedStyle(element).display === 'none') {
        element.style.display = 'block';
    }

    let height = element.scrollHeight;
    element.style.height = '0px';
    element.offsetHeight;
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = height + 'px';

    setTimeout(() => {
        element.style.removeProperty('height');
    }, duration);
}

document.addEventListener("DOMContentLoaded", function () {
    let searchBlock = document.querySelector(".js-search-block");
    let searchInput = document.querySelector(".js-search-input");
    let searchClose = document.querySelector(".js-search-close");

    let autoPopup = document.querySelector(".js-search-auto-popup");
    let suggestionsPopup = document.querySelector(".js-search-suggestions-popup");

    let popupClose = document.querySelector(".js-search-auto-popup-close");

    let tabWrappers = document.querySelectorAll(".search-suggestions-popup__data");

    if (searchBlock || searchInput) {
        // =========================
        // Popup Functions
        // =========================

        function showAutoPopup() {
            searchBlock.classList.add("shown-auto-popup");
            $('.pdp-radio--option:first').trigger('click');
        }

        function hideAutoPopup() {
            searchBlock.classList.remove("shown-auto-popup");
        }

        function showSuggestionsPopup() {
            //searchBlock.classList.add("shown-suggestions-popup");
        }

        function hideSuggestionsPopup() {
            searchBlock.classList.remove("shown-suggestions-popup");
        }

        function hideAllPopups() {
            hideAutoPopup();
            hideSuggestionsPopup();
        }

        // start suggestion product section render in search function seo issue fix 
        let searchProductsLoaded = false;
        let searchProductsLoading = false;

        function loadSearchProducts() {
            if (searchProductsLoaded || searchProductsLoading) {
            return;
            }

            const container = document.querySelector('.js-search-bestseller');

            if (!container) {
            return;
            }

            searchProductsLoading = true;

            fetch('/?section_id=search-function-best-sellers')
            .then(response => {
                if (!response.ok) {
                throw new Error('Failed to load search products');
                }

                return response.text();
            })
            .then(html => {
                container.innerHTML = html;
                if ($('.search-reco-products__item .pdp-radio--option').length) {
                    $('.search-reco-products__item .pdp-radio--option').trigger('change');
                }
                setTimeout(function() {
                if ($('.search-reco-products__item .custom_variant_selection').length > 0) {
                        $('.search-reco-products__item .custom_variant_selection').matchHeight({
                            byRow: true
                        });
                    }
                }, 1000);
                setTimeout(function() {
                if ($('.search-reco-products__item .card__heading .full-unstyled-link').length > 0) {
                    $('.search-reco-products__item .card__heading .full-unstyled-link').matchHeight({
                        byRow: true,
                    });
                };
                }, 1000);
                searchProductsLoaded = true;
                searchProductsLoading = false;
            })
            .catch(error => {
                searchProductsLoading = false;
            
            });
        }
        // end suggestion product section render in search function seo issue fix 

        // =========================
        // Input Click
        // =========================

        searchInput.addEventListener("click", function (e) {
            console.log("click");
            
            e.stopPropagation();

            if (searchInput.value.trim() === "") {
                hideSuggestionsPopup();
                showAutoPopup();
                loadSearchProducts(); 
            } else {
                hideAutoPopup();
                showSuggestionsPopup();
                
            }
        });

        // =========================
        // Input Typing
        // =========================

        searchInput.addEventListener("input", function () {

            const value = searchInput.value.trim();

            // Blank input
            if (value === "") {

                hideSuggestionsPopup();
                showAutoPopup();
                renderRecentSearches();   
            } else {

                hideAutoPopup();
                showSuggestionsPopup();

            }

        });

        // =========================
        // Search Close Button
        // =========================
      
        if (searchClose) {

            searchClose.addEventListener("click", function (e) {

                e.preventDefault();
                e.stopPropagation();

                searchInput.value = "";

                hideAllPopups();
                renderRecentSearches();


            });

        }

        // =========================
        // Auto Popup Close Button
        // =========================

        if (popupClose) {

            popupClose.addEventListener("click", function (e) {

                e.preventDefault();
                e.stopPropagation();

                hideAutoPopup();

            });

        }

        // =========================
        // Prevent Inner Click Close
        // =========================

        // if (autoPopup) {
        //     autoPopup.addEventListener("click", function (e) {
        //         e.stopPropagation();
        //     });
        // }

        // if (suggestionsPopup) {
        //     suggestionsPopup.addEventListener("click", function (e) {
        //         e.stopPropagation();
        //     });
        // }

        // =========================
        // Outside Click
        // =========================

        document.addEventListener("click", function (e) {

            const isInsideSearch = searchBlock.contains(e.target) ||
                (autoPopup && autoPopup.contains(e.target)) ||
                (suggestionsPopup && suggestionsPopup.contains(e.target));

            if (!isInsideSearch) {
                hideAllPopups();
            }

        });
    }


    if (tabWrappers.length) {
        tabWrappers.forEach(function (wrapper) {
            const tabButtons = wrapper.querySelectorAll(".search-suggestions-popup__tabs button");
            const tabDetails = wrapper.querySelectorAll(".suggestions-tab-detail__data");

            tabButtons.forEach(function (button) {
                button.addEventListener("click", function () {
                    const currentTab = button.getAttribute("data-tab");

                    // =========================
                    // Remove active tab class
                    // =========================

                    tabButtons.forEach(function (btn) {
                        btn.parentElement.classList.remove("is-active-tab");
                    });

                    // =========================
                    // Add active tab class
                    // =========================

                    button.parentElement.classList.add("is-active-tab");

                    // =========================
                    // Hide all tab details
                    // =========================

                    tabDetails.forEach(function (detail) {
                        detail.classList.remove("is-active-tab-detail");
                    });

                    // =========================
                    // Show matching tab detail
                    // =========================

                    const activeDetail = wrapper.querySelector('[data-tab-detail="' + currentTab + '"]');

                    if (activeDetail) {
                        activeDetail.classList.add("is-active-tab-detail");
                    }

                });
            });
        });
    }

    if (searchInput) {
        const placeholders = [
            "Organic CBD Gummies",
            "THC Gummies",
            "Tincture",
            "CBD Salve"
        ];

        let textIndex = 0;
        let charIndex = 0;
        let isDeleting = false;

        // SAME speed for every character
        const speed = 140;

        // Pause timings
        const pauseAfterTyping = 5000;
        const pauseAfterDeleting = 100;

        function animatePlaceholder() {

            const currentText = placeholders[textIndex];

            // ======================
            // Typing
            // ======================

            if (!isDeleting) {

            charIndex++;

            searchInput.setAttribute(
                "placeholder",
                currentText.substring(0, charIndex)
            );

            // Finished typing
            if (charIndex === currentText.length) {

                isDeleting = true;

                setTimeout(animatePlaceholder, pauseAfterTyping);
                return;
            }

            }

            // ======================
            // Deleting
            // ======================

            else {

            charIndex--;

            searchInput.setAttribute(
                "placeholder",
                currentText.substring(0, charIndex)
            );

            // Finished deleting
            if (charIndex === 0) {

                isDeleting = false;

                textIndex++;

                if (textIndex >= placeholders.length) {
                textIndex = 0;
                }

                setTimeout(animatePlaceholder, pauseAfterDeleting);
                return;
            }

            }

            // SAME timing for EVERY character
            setTimeout(animatePlaceholder, speed);

        }

        animatePlaceholder();
    }


    document.querySelectorAll('.js-filter-wrapper').forEach((wrapper) => {
        const headings = wrapper.querySelectorAll('.js-filter-heading');

        headings.forEach((heading, index) => {
            console.log("headings : ", headings);
            
            const detail = heading.nextElementSibling;
            const block = heading.closest('.suggestions-product__filters-block');

            // Optional: Start closed
            detail.style.display = 'none';

            if (index === 0) {
                detail.style.display = 'block';

                heading.classList.add('is-active');
                block.classList.add('is-active-filter');

            } 

            heading.addEventListener('click', () => {
                const isOpen = getComputedStyle(detail).display !== 'none';

                // Close all accordion items inside current wrapper
                /*
                wrapper.querySelectorAll('.js-filter-detail').forEach((item) => {

                    const parentBlock = item.closest('.suggestions-product__filters-block');
                    const parentHeading = item.previousElementSibling;

                    if (item !== detail && getComputedStyle(item).display !== 'none') {
                        slideUp(item);

                        parentHeading.classList.remove('is-active');
                        parentBlock.classList.remove('is-active-filter');
                    }
                });
                */

                // Toggle current accordion
                if (isOpen) {
                    slideUp(detail);

                    heading.classList.remove('is-active');
                    block.classList.remove('is-active-filter');

                } else {
                    slideDown(detail);

                    heading.classList.add('is-active');
                    block.classList.add('is-active-filter');
                }
            });
        });
    }); 

});

$(document).ready(function () {
    if ($('.js-search-auto-popup .card__content .card__heading').length > 0) {
        $('.js-search-auto-popup .card > .card__content .card__heading .full-unstyled-link').matchHeight({
            byRow: true,
        });
    }

    if ($('.js-search-auto-popup .card__content .eq-collection-benefits-badge').length > 0) {
        $('.js-search-auto-popup .card__content .eq-collection-benefits-badge').matchHeight({
            byRow: true,
        });
    };


    if ($('.js-search-suggestions-popup .suggestions-product__product-row .card__content .card__heading').length > 0) {
        $('.js-search-suggestions-popup .suggestions-product__product-row .card > .card__content .card__heading .full-unstyled-link').matchHeight({
            byRow: true,
        });
    }

    if ($('.js-search-suggestions-popup .suggestions-product__product-row .card__content .eq-collection-benefits-badge').length > 0) {
        $('.js-search-suggestions-popup .suggestions-product__product-row .card__content .eq-collection-benefits-badge').matchHeight({
            byRow: true,
        });
    };
});